var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('meta', {
    attrs: {
      "http-equiv": "Cache-Control",
      "content": "no-cache"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "http-equiv": "Pragma",
      "content": "no-cache"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "http-equiv": "Expires",
      "content": "0"
    }
  }), _vm._v(" "), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "dashboard"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler sidebar-toggler d-md-down-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    staticStyle: {
      "margin-right": "2%"
    },
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/default-img.png",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none",
    staticStyle: {
      "color": "#000 !important"
    }
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "id": "logout"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 2)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da79ce6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 359
// module chunks = 1